<template>
  <div id="app">
    <router-view />
    <Language />
    <Footer />
  </div>
</template>

<script>
export default {
  watch: {
    '$route' (to, from) {
      document.title = to.meta.title || 'TrioMarkets'
    }
  }
}
</script>

<style lang="scss">

</style>
